<p *ngIf="fieldDescription" class="mb-0 mt-2">
  {{ fieldDescription }}{{ getRequired() ? '*' : '' }}
</p>
<mat-form-field
  *ngIf="!readonly"
  class="w-100"
  [floatLabel]="'always'"
  [ngClass]="{ 'allow-pointer': tooltipText, 'no-label': hideLabel }"
>
  <mat-label>
    {{ labelOverride || fgInfo?.label
    }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
    <mat-icon
      [hidden]="!tooltipText"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="'after'"
      [attr.aria-label]="'Tooltip: ' + tooltipText"
      tabindex="0"
    >
      help
    </mat-icon>
  </mat-label>
  <input
    [formControl]="formControl"
    type="text"
    placeholder="Email Address"
    aria-label="email Address"
    [required]="true"
    matInput
    [matAutocomplete]="auto"
    (change)="onTextChanged($event)"
  />
  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event)"
  >
    <mat-option *ngFor="let item of adUsers$ | async; let index = index" [value]="item">
      {{ item }}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </mat-error>
</mat-form-field>
<span *ngIf="formControl.valid && isKnownEmailAddress === false">
  This user's email address does not belong to a WCB member.
</span>
